import get from "lodash/get";
import * as TYPES from "../../constants/actionTypes";

const intialState = {
  locationHierarchy: [],
  userZoneLocations: {
    zoneList: [],
    locationList: [],
    companyList: [],
    clientList: [],
  },
};

const LocationReducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.LOCATION_UPDATE:
      return {
        ...state,
        userZoneLocations: {
          zoneList: get(action, "payload.userZoneLocationVO.zoneList") || [],
          locationList:
            get(action, "payload.userZoneLocationVO.locationList") || [],
          companyList:
            get(action, "payload.userZoneLocationVO.companyList") || [],
          clientList:
            get(action, "payload.userZoneLocationVO.clientList") || [],
        },
      };

    default:
      return state;
  }
};
export default LocationReducer;
